import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: '#df451f',
    className: null,
};

const DotsIcon = ({ color, className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="13px"
        height="13px"
        className={className}
    >
        <path
            fillRule="evenodd"
            fill={color}
            d="M6.734,0.000 C10.195,0.000 13.000,2.910 13.000,6.500 C13.000,10.090 10.195,13.000 6.734,13.000 C3.274,13.000 0.469,10.090 0.469,6.500 C0.469,2.910 3.274,0.000 6.734,0.000 Z"
        />
    </svg>
);

DotsIcon.propTypes = propTypes;
DotsIcon.defaultProps = defaultProps;

export default DotsIcon;
